import { render } from "./MemosJournal.vue?vue&type=template&id=4ecba778&scoped=true"
import script from "./MemosJournal.vue?vue&type=script&lang=js"
export * from "./MemosJournal.vue?vue&type=script&lang=js"

import "./MemosJournal.vue?vue&type=style&index=0&id=4ecba778&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ecba778"]])

export default __exports__